export const PAYOUTS = [
  3240000,
  1944000,
  1224000,
  864000,
  720000,
  648000,
  603000,
  558000,
  522000,
  486000,
  450000,
  414000,
  378000,
  342000,
  324000,
  306000,
  288000,
  270000,
  252000,
  234000,
  216000,
  201600,
  187200,
  172800,
  158400,
  144000,
  138600,
  133200,
  127800,
  122400,
  117000,
  110600,
  106200,
  101700,
  97200,
  92700,
  88200,
  84600,
  81000,
  77400,
  73800,
  70200,
  66600,
  55800,
  52200,
  49320,
  46800,
  45360,
  44280,
  44280,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
];
